import { UserRole } from '../types/types';

/** Admin portal: offers and in-app banner management */
export const MARKETING_CONTENT_ROLES: UserRole[] = [
    UserRole.Admin,
];

/** Admin portal: marketing analytics dashboards */
export const MARKETING_DASHBOARD_ROLES: UserRole[] = [
    UserRole.Admin,
    UserRole.ProductAdmin,
];

/** Admin portal: SEO dashboard */
export const SEO_PORTAL_ROLES: UserRole[] = [
    UserRole.Admin,
    UserRole.ProductAdmin,
    UserRole.Finance,
];

export const SEO_KEYWORD_WRITE_ROLES: UserRole[] = [
    UserRole.Admin,
    UserRole.ProductAdmin,
];

/** Admin portal: Marketing Admin may only open their own user profile */
export const MARKETING_ADMIN_PROFILE_PATH = (userId: string) => `/users/${userId}`;

export const isMarketingAdminRole = (role: UserRole | null | undefined) =>
    role === UserRole.MarketingAdmin;
